import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  clientDetails: null,
  brokerage: null,
  allocation: null,
  holdings: null,
  investmentLoading: false,
  initiate_payment_loading: false,
  fetchedClient: false,
  clientLoading: false,
  holdingsLoading: false,
  paymentsRecorded: null,
};

const investmentsSlice = createSlice({
  name: "investments",
  initialState,
  reducers: {
    setClientDetails: (state, action) => {
      state.clientDetails = action.payload;
    },
    setBrokerage: (state, action) => {
      state.brokerage = action.payload;
    },
    setAllocation: (state, action) => {
      state.allocation = action.payload;
    },
    setHoldings: (state, action) => {
      state.holdings = action.payload;
    },
    setInvestmentLoading: (state, action) => {
      state.investmentLoading = action.payload;
    },
    setInitiatePaymentLoading: (state, action) => {
      state.initiate_payment_loading = action.payload;
    },
    setFetchedClient: (state, action) => {
      state.fetchedClient = action.payload;
    },
    setClientLoading: (state, action) => {
      state.clientLoading = action.payload;
    },
    setHoldingsLoading: (state, action) => {
      state.holdingsLoading = action.payload;
    },
    resetInvestmentSlice: (state, action) => {
      state.clientDetails = null;
      state.fetchedClient = false;
    },
    setPaymentsRecorded: (state, action) => {
      state.paymentsRecorded = action.payload;
    },
  },
});

export const { setClientDetails, setBrokerage, setAllocation, setHoldings, setInvestmentLoading, setInitiatePaymentLoading, setFetchedClient, setClientLoading, setHoldingsLoading, resetInvestmentSlice, setPaymentsRecorded } = investmentsSlice.actions;
export default investmentsSlice.reducer;
